export default __webpack_public_path__ + "static/media/11.97fb5354.webp";